import styled from 'styled-components';
import ButtonWithStyles from '../Button/Button.js';
import { ndsScreenReaderOnly } from '../../utilities/styles/utils.js';

// doesn't have `:hover` state, which is required by VO on iOS for this button to work properly.

var HiddenCloseButton = styled(ButtonWithStyles).attrs({
  variant: 'secondary'
}).withConfig({
  displayName: "HiddenCloseButton",
  componentId: "sc-1sj86tb-0"
})(["", " font-size:15px;&:hover,&:focus,&:active{width:100px;height:45px;right:15px;bottom:15px;clip:auto;}"], ndsScreenReaderOnly());

export default HiddenCloseButton;
